<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 16,
      height: 17,
      color: 'currentColor',
      viewBoxValue: `0 0 16 17`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M10.6667 4.49999V3.96666C10.6667 3.21992 10.6667 2.84656 10.5213 2.56134C10.3935 2.31046 10.1895 2.10648 9.93865 1.97865C9.65344 1.83333 9.28007 1.83333 8.53333 1.83333H7.46667C6.71993 1.83333 6.34656 1.83333 6.06135 1.97865C5.81046 2.10648 5.60649 2.31046 5.47866 2.56134C5.33333 2.84656 5.33333 3.21992 5.33333 3.96666V4.49999M6.66667 8.16666V11.5M9.33333 8.16666V11.5M2 4.49999H14M12.6667 4.49999V11.9667C12.6667 13.0868 12.6667 13.6468 12.4487 14.0746C12.2569 14.451 11.951 14.7569 11.5746 14.9487C11.1468 15.1667 10.5868 15.1667 9.46667 15.1667H6.53333C5.41323 15.1667 4.85318 15.1667 4.42535 14.9487C4.04903 14.7569 3.74307 14.451 3.55132 14.0746C3.33333 13.6468 3.33333 13.0868 3.33333 11.9667V4.49999"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
